import React, { Component, useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import config from '../config.js';
import Payment from './Payment.js';

import './Subscription.css';

const stripePromise = loadStripe(config.stripe.publicKey);

export default class Subscription extends Component {
   constructor(props) {
      super(props);

      const { premium: premiumSubscription, basic: basicSubscription } = config.subscriptions;

      this.state = {
         subscription: props.page === props.pages.subscriptionPremium || props.subscription === basicSubscription.type ? premiumSubscription.type : basicSubscription.type
      };
   }

   componentDidUpdate(props) {
      const { premium: premiumSubscription, basic: basicSubscription } = config.subscriptions;

      if (props.subscription !== this.props.subscription) {
         if (this.props.subscription === basicSubscription.type) {
            this.setState({ subscription: premiumSubscription.type });
         }
      }
      
      if (props.page !== this.props.page) {
         if (this.props.page === props.pages.subscriptionPremium) {
            this.setState({ subscription: premiumSubscription.type });
         }
         else if (this.props.page === props.pages.subscriptionBasic) {
            this.setState({ subscription: basicSubscription.type });
         }
      }
   }

   select(subscription) {
      if (this.isDisabled(subscription)) {
         return;
      }
      const { premium: premiumSubscription } = config.subscriptions;

      window.location.hash = subscription === premiumSubscription.type ? this.props.pages.subscriptionPremium : this.props.pages.subscriptionBasic;      
      this.setState({ subscription });
   };
   
   isDisabled(option) {
      if (this.state.isPaymentProcessing) {
         return true;
      }
      
      if (this.props.subscription) {
         const { premium: premiumSubscription, basic: basicSubscription } = config.subscriptions;

         if (this.props.subscription === premiumSubscription.type || this.props.subscription === basicSubscription.type && option === basicSubscription.type) {
            return true;
         }
      }
      
      return false;
   };

   render() {
      const { subscription } = this.state;
      const { premium: premiumSubscription, basic: basicSubscription } = config.subscriptions;

      // The actual payment intent is created server-side, amount here is for Stripe Elements initialization
      const amount = subscription === basicSubscription.type ? basicSubscription.price * 100 : premiumSubscription.price * 100;
      const options = {
         mode: 'payment',
         amount,
         currency: 'eur',
         locale: 'bg',
         appearance: {
            theme: 'stripe',
            variables: {
               colorPrimary: subscription === basicSubscription.type ? '#5fc488' : '#ff9500',
            }
         }
      };
      
      const basicDisabled = this.isDisabled(basicSubscription.type);
      const premiumDisabled = this.isDisabled(premiumSubscription.type);

      const basicSelected = !this.props.subscription && subscription === basicSubscription.type;
      const premiumSelected = !this.props.subscription && subscription === premiumSubscription.type || this.props.subscription === basicSubscription.type;

      return (
         <section className="Subscription">
            <article>
               <h3>Предимства на абонамента</h3>
               <p>Калкулаторът изчислява шансовете за класиране към текущия момент. Това означава, че записването на нови деца в системата на детските градини на София (<b>kg.sofia.bg</b>), както и разместването на желаният на останалите кандидатстващи деца се отразява пряко върху шансовете и те се променят с времето.</p>
               <p>За да има калкулаторът максимален ефект, шансовете е добре да се проверяват поне веднъж седмично в началото и ежедневно през последните седмици преди класирането. Така, ако се налага, могат да се взимат своеверменни мерки:</p>
               <ul>
                  <li>Разместване подредбата на текущите желания</li>
                  <li>Премахване на детски градини, където конкуренцията е твърде голяма и шансовете са много ниски</li>
                  <li>Добавяне на детски градини с новооткрити места или отлив на желаещи</li>
               </ul>
               
               <h3>Какво представляват абонаментите</h3>
               <p>Абонаментът е персонален за всяко едно дете и е свързан с неговото ID:</p>
               <ul>
                  <li>Предоставя възможност за неограничен брой изчисления на шансовете за класиране</li>
                  <li>Важи за всички класирания през текущата календарна година</li>
                  <li>Валиден е до 31 декември на текущата година независимо от датата на плащане</li>
                  <li>Не може да се прехвърля за класирания през следващата календарна година</li>
               </ul>

               <div className="subscriptions">
                  <div className={`${this.props.subscription === basicSubscription.type ? 'active' : ''} ${basicSelected ? 'selected' : ''} ${basicDisabled ? 'disabled' : ''}`} onClick={() => this.select(basicSubscription.type)}>
                     {this.props.subscription === basicSubscription.type && <span>Активен</span>}
                     <h4>{basicSubscription.name}</h4>
                     <p>{basicSubscription.regularPrice > basicSubscription.price && (<strike>€{basicSubscription.regularPrice}</strike>)} €{basicSubscription.price}</p>
                     <ul>
                        <li>✓ Изчисляване на шансовете при текущата подредба на желанията</li>
                        <li>✓ Неограничен брой изчисления за текущата календарна година</li>
                     </ul>
                  </div>
                  
                  <div className={`premium ${this.props.subscription === premiumSubscription.type ? 'active' : ''} ${premiumSelected ? 'selected' : ''} ${premiumDisabled ? 'disabled' : ''}`} onClick={() => this.select(premiumSubscription.type)}>
                     {this.props.subscription === premiumSubscription.type && <span>Активен</span>}
                     <h4>{premiumSubscription.name}</h4>
                     <p>{premiumSubscription.regularPrice > premiumSubscription.price && (<strike>€{premiumSubscription.regularPrice}</strike>)} €{premiumSubscription.price}</p>
                     <ul>
                        <li>✓ Всички функции от базовия план</li>
                        <li>✓ Анализ на всички възможни разпределения на бонус точките</li>
                        <li>✓ Предложения за пренареждане на желанията за оптимизация на шансовете </li>
                     </ul>
                  </div>
               </div>
            </article>
            <aside>
               <h3>Плати абонамент{this.props.id ? ` за ID ${this.props.id}` : ''}</h3>
               {this.props.subscription ? (
                  <>
                     <strong className={this.props.subscription === premiumSubscription.type ? 'premium' : 'basic'}>
                        Активен абонамент: <b>{this.props.subscription === basicSubscription.type ? basicSubscription.name : premiumSubscription.name}</b>
                     </strong>
                     
                     {this.props.subscription === basicSubscription.type ? (
                        <>
                           <p>
                              Можете да надградите до <b>{premiumSubscription.name}</b> за по-задълбочен анализ и предложения за оптимизация на шансовете.
                           </p>
                           <dl className="premium selected">
                              <dt>{premiumSubscription.name}{this.props.id ? <p>ID {this.props.id}</p> : null}</dt>
                              <dd>{premiumSubscription.upgrade.regularPrice > premiumSubscription.upgrade.price && (<strike>€{premiumSubscription.upgrade.regularPrice}</strike>)} €{premiumSubscription.upgrade.price}</dd>
                           </dl>
                           <em>
                              <span>Плащане на <b>{premiumSubscription.name}</b></span>
                              <span>€{premiumSubscription.upgrade.price}</span>
                           </em>

                           <Elements stripe={stripePromise} options={options}>
                              <Payment subscription={premiumSubscription.type} id={this.props.id} year={this.props.year} planType={premiumSubscription.type} />
                           </Elements>
                        </>
                     ) : (
                        <p>Разполагате с активен <b>{premiumSubscription.name}</b> за текущата година. Няма нужда от подновяване.</p>
                     )}
                  </>
               ) : (
                  <>
                     <dl className={`basic ${subscription === basicSubscription.type ? 'selected' : ''}`} onClick={() => this.select(basicSubscription.type)}>
                        <dt>{basicSubscription.name}{this.props.id ? <p>ID {this.props.id}</p> : null}</dt>
                        <dd>{basicSubscription.regularPrice > basicSubscription.price && (<strike>€{basicSubscription.regularPrice}</strike>)} €{basicSubscription.price}</dd>
                     </dl>    
                     <dl className={`premium ${subscription === premiumSubscription.type ? 'selected' : ''}`} onClick={() => this.select(premiumSubscription.type)}>
                        <dt>{premiumSubscription.name}{this.props.id ? <p>ID {this.props.id}</p> : null}</dt>
                        <dd>{premiumSubscription.regularPrice > premiumSubscription.price && (<strike>€{premiumSubscription.regularPrice}</strike>)} €{premiumSubscription.price}</dd>
                     </dl>
                     
                     <em>
                        <span>Плащане на <b>{subscription === basicSubscription.type ? basicSubscription.name : premiumSubscription.name}</b></span>
                        <span>{subscription === basicSubscription.type ? `€${basicSubscription.price}` : `€${premiumSubscription.price}`}</span>
                     </em>
                     
                     <Elements stripe={stripePromise} options={options}>
                        <Payment subscription={subscription} id={this.props.id} year={this.props.year} planType={subscription} />
                     </Elements>
                  </>
               )}
            </aside>
         </section>
      );
   }
}